import Swal from 'sweetalert2'

export default {
  install: (app) => {
    
    app.config.globalProperties.$confirm = async (title, text, options = {}) => {
      const result = await Swal.fire({
        title: title || 'Confirmación',
        text: text,
        //icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: localStorage.getItem('color_base') || '#fd7527',
        customClass: {
          popup: 'text-sm',
          confirmButton: 'text-sm',
          cancelButton: 'text-sm'
        },
        ...options, // permite sobreescribir opciones si se desea
      })
      return result.isConfirmed
    }
  }
}
